import React from 'react'
import { Image } from 'react-bootstrap'

const PageHeading = ({ image, text ,color,center,heading}) => {
    return (
        <>
            <div  className={`d-flex align-items-center  ${center?"justify-content-center":""} `}>
                {image ?
                    <div  className={`${heading?"":"mb-2"}`} style={{ width: "30px",  }}>
                        <Image
                            src={image}
                            alt="logo"
                            className='w-100'
                        />
                    </div>
                    : ""}


                {heading  ?
                        <h4 className='ms-2 mb-0 text-capitalize ' style={{color:color?color:""}}>


                            <strong>{heading}</strong>
                        </h4>
                    : ""}
                {text  ?
                        <p className='mb-0 ms-2 text-uppercase' style={{color:color?color:""}}>
<strong>{text}</strong>
                        </p>
                    : ""}
            </div>
        </>
    )
}

export default PageHeading